import React from "react";
import {
  Dialog,
  DialogContent,
  DialogTitle,
  Typography,
  Button,
  IconButton,
  Box,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { IoIosCalendar } from "react-icons/io";
import { GoClockFill } from "react-icons/go";

import FileNotselected from "../../../../Assets/Icons/FileNotselected.png";
import TickIcon from "../../../../Assets/Icons/TickIcon.png";

export default function SlotBookingStatus({ open, status, onClose }) {
  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" >
      <DialogTitle>
        <Box display="flex" justifyContent="flex-end">
          <IconButton onClick={onClose}>
            <CloseIcon />
          </IconButton>
        </Box>
      </DialogTitle>
      <DialogContent sx={{ textAlign: "center", pb: 4 }}>
        {status === "filled" ? (
          <>
            <Box
              component="img"
              src={FileNotselected}
              alt="Slot Not Available"
              sx={{ width: 60, height: 60, mb: 2 }}
            />
            <Typography
              sx={{
                color: "rgba(55, 58, 69, 1)",
                fontSize: "1rem",
                fontWeight: "600",
              }}
              gutterBottom
            >
              The slot that you selected is not available any more.
            </Typography>
            <Typography
              sx={{
                mb: 3,
                color: "rgba(88, 90, 100, 1)",
                fontSize: "0.75rem",
              }}
            >
              Please select a different slot to continue booking.
            </Typography>
            <Button
              variant="contained"
              sx={{
                backgroundColor: "rgba(71, 113, 43, 1)",
                "&:hover": {
                  backgroundColor: "rgba(71, 113, 43, 1)",
                  boxShadow: "none",
                },
              }}
              onClick={onClose}
            >
              Choose a different slot
            </Button>
          </>
        ) : (
          <>
            <Box
              component="img"
              src={TickIcon}
              alt="Slot Booked Successfully"
              sx={{ width: 60, height: 60, mb: 2 }}
            />
            <Typography
              sx={{
                color: "rgba(55, 58, 69, 1)",
                fontSize: "1rem",
                fontWeight: "600",
              }}
              gutterBottom
            >
              Slot booked successfully
            </Typography>

            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                gap: 2,
                border: "1px solid rgba(71, 113, 43, 1)",
                borderRadius: "8px",
                padding: "8px 16px",
                mb: 3,
                width: "fit-content",
                background: "rgba(237, 241, 234, 1)",
                margin: "0 auto",
              }}
            >
              {/* Date Section */}
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  gap: 1,
                  borderRight: "1px solid rgba(71, 113, 43, 1)",
                  pr: 2,
                }}
              >
                <IoIosCalendar size={18} color="rgba(71, 113, 43, 1)" />
                <Typography variant="body1">13th March</Typography>
              </Box>

              {/* Time Section */}
              <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                <GoClockFill size={18} color="rgba(71, 113, 43, 1)" />
                <Typography variant="body1">09:00 AM IST</Typography>
              </Box>
            </Box>

            <Typography
              sx={{
                m: 3,
                color: "rgba(88, 90, 100, 1)",
                fontSize: "0.75rem",
              }}
            >
              We have sent you a confirmation email to <b>abc@gmail.com</b>.
              <br />
              The meeting link will be shared with you ahead of the scheduled
              time.
            </Typography>
          </>
        )}
      </DialogContent>
    </Dialog>
  );
}
